import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { TranslateModule } from '@ngx-translate/core'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'

import { CustomFieldModule } from '../custom-field'
import { AddressFormFieldControlComponent } from './address-field.component'

@NgModule({
  imports: [
    CommonModule,
    CustomFieldModule,
    FlexLayoutModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [AddressFormFieldControlComponent],
  exports: [AddressFormFieldControlComponent],
})
export class AddressFieldModule {}
